import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { withRouter, Redirect } from 'react-router-dom';
import WorkVisualsSlider from './WorkVisualsSlider';

class AllWorks extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if(window.innerWidth < 1024) {
            return <Redirect to="/"/>
        }
        
        return (
            <div className="container">
                <Helmet>
                    <title>La Roulotte Retouche - All Works</title>
                    <body className="all-works" />
                </Helmet>

                <div className="all-works-content">
                    {this.props.projects.map((project, index) => {
                        if(project.sliderImages) {
                            // // Prepare slider assets list
                            // let assetsCount = parseInt(project.sliderImages, 10);
                            // let assets = [];

                            // for(let i = 0; i < assetsCount; i ++) {
                            //     let assetIndex = (i + 1 < 10) ? `0${i + 1}` : i + 1;
                                
                            //     // `/assets/img/dancers/dancer-1@${this.pixelDensity}x.jpg`,
                            //     assets.push(`/assets/img/all-works/${project.path}/${assetIndex}.jpg`);
                            // }

                            // Find project name
                            var projectName = project.details.left.find(detail => {
                                return ['Client', 'Project', 'Magazine', 'Agency'].includes(detail.title);
                            });

                            if(projectName) {
                                projectName = projectName.label.replace('...', '');
                            }                        

                            return <WorkVisualsSlider key={index} assets={project.sliderImages} projectName={projectName} projectPath={project.path} sliderNavAlign={project.sliderNavAlign} rotation={project.rotation} details={project.details}/>
                        }

                        return null;
                    })}
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        projects: state.assets.projects
    };
};

export default withRouter(connect(mapStateToProps, null)(AllWorks));


// WEBPACK FOOTER //
// ./src/components/AllWorks.js